import React from 'react';

const NotFound = () => {
  return(
    <section id="not-found" className="flex bold">
      <p>404<br/>Page Not Found</p>
    </section>
  );
}

export default NotFound;
